export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_SCHOOL = "ROLE_SCHOOL";
export const ROLE_PRINCIPAL = "ROLE_PRINCIPAL";
export const ROLE_TEACHER = "ROLE_TEACHER";
export const ROLE_STAFF = "ROLE_STAFF";
export const ROLE_PARENT = "ROLE_PARENT";
export const ROLE_USER = "ROLE_USER";
export const ROLE_STUDENT = "ROLE_STUDENT";

const ROLE_ALIAS_MAP = {
  ROLE_SUPERADMIN: ROLE_SUPER_ADMIN,
  ROLE_SUPER_ADMINISTRATOR: ROLE_SUPER_ADMIN,
  ROLE_TENANT: ROLE_SCHOOL,
  ROLE_SCHOOL_REP: ROLE_SCHOOL,
  ROLE_SCHOOL_ADMIN: ROLE_SCHOOL,
  ROLE_SCHOOL_OWNER: ROLE_SCHOOL,
  ROLE_ADMINISTRATOR: ROLE_ADMIN,
  ROLE_PARENT_GUARDIAN: ROLE_PARENT,
  ROLE_GUARDIAN: ROLE_PARENT,
  ROLE_EMPLOYEE: ROLE_STAFF,
  ROLE_LIBRARIAN: ROLE_STAFF,
  ROLE_ACCOUNTANT: ROLE_STAFF,
  ROLE_CLERK: ROLE_STAFF,
};

export const ADMIN_ROLES = [ROLE_SUPER_ADMIN, ROLE_ADMIN];
export const STUDENT_ROLES = [ROLE_USER, ROLE_STUDENT];
export const SCHOOL_ROLES = [ROLE_SCHOOL, ROLE_PRINCIPAL];
export const STAFF_ROLES = [ROLE_STAFF];
export const PARENT_ROLES = [ROLE_PARENT];
export const MANAGEMENT_ROLES = [...ADMIN_ROLES, ...SCHOOL_ROLES];
export const ALL_APP_ROLES = [
  ...ADMIN_ROLES,
  ROLE_SCHOOL,
  ROLE_PRINCIPAL,
  ROLE_TEACHER,
  ROLE_STAFF,
  ROLE_PARENT,
  ROLE_USER,
  ROLE_STUDENT,
];

export const normalizeRole = (rawRole) => {
  if (!rawRole) return "";

  const roleValue = String(rawRole).trim().toUpperCase();
  if (!roleValue) return "";

  const roleWithPrefix = roleValue.startsWith("ROLE_")
    ? roleValue
    : `ROLE_${roleValue}`;

  return ROLE_ALIAS_MAP[roleWithPrefix] || roleWithPrefix;
};

export const getDashboardPathForRole = (role) => {
  const normalizedRole = normalizeRole(role);

  if (normalizedRole === ROLE_SUPER_ADMIN) return "/super-admin";
  if (normalizedRole === ROLE_PRINCIPAL) return "/principal";
  if (ADMIN_ROLES.includes(normalizedRole)) return "/admin-board";
  if (STAFF_ROLES.includes(normalizedRole)) return "/school-dashboard";
  if (normalizedRole === ROLE_TEACHER) return "/teacher-dashboard";
  if (SCHOOL_ROLES.includes(normalizedRole)) return "/school-dashboard";
  if (PARENT_ROLES.includes(normalizedRole)) return "/user-dashboard";
  if (STUDENT_ROLES.includes(normalizedRole)) return "/user-dashboard";
  return "/";
};

export const canShowCustomizeMenu = (role) =>
  STUDENT_ROLES.includes(normalizeRole(role));
